import { inject, Injectable } from '@angular/core';
import { OptionStore } from '../stores';

@Injectable({ providedIn: 'root' })
export class SystemOptionsService {
  private readonly store = inject(OptionStore);
}
